module.exports = __webpack_public_path__ + "static/media/(H)_MG_4627_-_bijuterias_-_acessorios.a135ce2f.jpg";